import { cssVar } from './cssVar';

/**
 * Named font-weight tokens, mirroring Tailwind's font-weight scale exposed
 * through the `--font-weight-*` custom properties. Each token maps to its
 * numeric fallback, so the value still resolves in apps that don't load the
 * Tailwind stylesheet.
 */
export const FONT_WEIGHT_VALUE = {
  thin: '100',
  extralight: '200',
  light: '300',
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extrabold: '800',
  black: '900',
} as const;

export type FontWeightToken = keyof typeof FONT_WEIGHT_VALUE;

/**
 * Shortcut for a Tailwind font-weight value, so styled-components can write
 * `font-weight: ${fontWeight('medium')};` instead of
 * `font-weight: ${({ theme }) => theme.tw.font.weight.medium};`.
 *
 * Resolves to `var(--font-weight-<token>, <fallback>)` — the same runtime token
 * as the Tailwind `font-medium` utility. The value is theme-independent (every
 * theme merges the same scale), so no `theme` access is required.
 */
export const fontWeight = (token: FontWeightToken): string =>
  cssVar(`--font-weight-${token}`, FONT_WEIGHT_VALUE[token]);
